export function formatWindowsFolderId(id) {
  return id?.replace(/\\/g, '/');
}
